import Strategy from './strategy';
import UnitConfig from '../unitConfig';
import alertOperateUnitModal from '../operateUnitModal';
import EnumOperates from 'src/enums/enumOperates';
import { Toast } from 'src/util/toast';
import MeasureTypeApi from '../api/measureTypeApi';

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 19:43:00
 */

export default class MeasureTypeService implements Strategy {
    ctx: UnitConfig
    constructor(ctx: UnitConfig) {
        this.ctx = ctx
    }
    async add() {
       let res = await alertOperateUnitModal(EnumOperates.Add.getName(), '测量类型')
       if(res) {
            this.searchList()
       }
    }

    async update(item: {id: number, name: string}) {
        let res = await alertOperateUnitModal(EnumOperates.Update.getName(), '测量类型', item.id, item.name)
        if(res) {
             this.searchList()
        }
    }

    async init() {
        this.searchItems()
        await this.searchList()
        if(this.ctx.leftData.length>0) {
            this.ctx.currentMenu = this.ctx.leftData[0].id
            this.searchRelationById(this.ctx.currentMenu)
        }
    }

    async delete(id){
        if(!await Toast.confirm()) {return}
        let {code} = await MeasureTypeApi.delete(id)
        if(code === 0) {
            if(id === this.ctx.currentMenu) {
                this.init()
            } else{
                this.searchList()
            }
            Toast.success('删除成功')
        }
    }

    async searchList() {
        let {data,code} = await MeasureTypeApi.searchList()
        if(code === 0) {
            this.ctx.leftData = data.data_info
        }
    }
    async searchItems(){
        let {data,code} = await MeasureTypeApi.searchMeasureType()
        if(code === 0) {
            this.ctx.rightData = data.map(i=> ({name: i.data_name, id: i.id}))
        }
    }

    async searchRelationById(id: number) {
        let {data,code} = await MeasureTypeApi.searchRelation(id)
        if(code === 0) {
            this.ctx.checkData = data.map(i=> i.data_type_id)
        }
    }

    async updateRelation(id: number) {
        this.ctx.loading = true
        let {data,code} = await MeasureTypeApi.updateRelation(id, this.ctx.checkData)
        this.ctx.loading = false
        if(code === 0) {
            Toast.success('保存成功')
        }
    }
}